<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>设备编码：</label>
                        <el-input v-model="search_Obj.f_device_code" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>任务ID：</label>
                        <el-input v-model="search_Obj.f_task_id" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>功能编码：</label>
                        <el-input v-model="search_Obj.f_code" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>                    
                    <div class="searchGroup">
                        <label>操作时间：</label>
                        <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="dateRangeSet"
                            style="width:420px">
                        </el-date-picker>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column prop="device_code" label="设备编号" sortable="custom"></el-table-column>
                        <el-table-column prop="task_id" label="任务ID" sortable="custom"></el-table-column>
                        <el-table-column prop="code" label="功能编码" sortable="custom"></el-table-column>
                        <el-table-column prop="add_time" label="时间" sortable="custom"></el-table-column>
                        <el-table-column prop="message" label="报文内容" sortable="custom"></el-table-column>
                        <el-table-column label="操作" width="120" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Info
                    width="800px"
                    :id1="model_id1"
                    title="查看报文日志"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'messageLogList',
    mixins: [listutil],
    components: { Info, Btns, LabBtns},
    data() {
        return {
            m_name: '报文日志',
            menu_id: 1920,
            list_url: "/api/admin/messagelog/list",
            search_Obj: {
                f_code: '',
                f_device_code: '',
                f_task_id: '',
            },
            del_Obj:{
                url:'/api/admin/messagelog/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            sortData: {
                prop: 'add_time',
                order: 'descending'
            },
            model_id1: '',
            dateRange: [],
        };
    },
    methods: {
        info(index, row) {
            this.model_id1 = row.id1
            this.infoshow = true
        },
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_add_time_s_date = val[0]
                this.search_Obj.f_add_time_e_date = val[1]
            }else{
                this.search_Obj.f_add_time_s_date = ''
                this.search_Obj.f_add_time_e_date = ''
            }
        },
    }
};
</script>